import { render } from "./AddingQAndC.vue?vue&type=template&id=12d057c2&scoped=true"
import script from "./AddingQAndC.vue?vue&type=script&lang=js"
export * from "./AddingQAndC.vue?vue&type=script&lang=js"

import "./AddingQAndC.vue?vue&type=style&index=0&id=12d057c2&scoped=true&lang=css"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d057c2"]])

export default __exports__